import FilesService from "./files.service";

// import UserGemsService from "./user.gems.service";
export default class StorageService extends FilesService {
  namespace = "file";
  template = "storageTemplate";
  DOMAIN = 166;
  icon = "GreenCabinet";
  Width = 1200;
  action = "action";
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;

  constructor() {
    super("files");
  }
}
